import React from 'react';
import { ClipLoader } from 'react-spinners';

const Loader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <ClipLoader size={50} color={"#fdfdfd"} loading={true} />
  </div>
);

export default Loader;